import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { DPPageWrapper } from "Components/DP";
import { PageNotFound } from "..";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { HelpText } from "Components/Shared/HelpText/HelpText";
import { RewardsDownloadButton } from "./RewardsDownloadButton/RewardsDownloadButton";
import { RewardsTable } from "./RewardsTable/RewardsTable";
import { RewardFilters } from "./RewardFilters/RewardFilters";
import useStyles from "./styles";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";

const RewardsReport = () => {
  const classes = useStyles();
  const { rewardsOptions, permissions } = usePartnerConfig();

  const onPageLoad = () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.RewardReportPageViewed,
    });
  };

  const hidePage =
    !rewardsOptions?.enableRewards ||
    !permissions.canListRewards;

  if (hidePage) {
    return <PageNotFound />;
  }

  return (
    <DPPageWrapper title="REWARD Report" onPageLoad={onPageLoad}>
      <Grid container spacing={2}>
        <Grid item >
          <Typography variant="h2" >
            REWARD Report
          </Typography>
        </Grid>
        <HelpText>
          <b>What is this?</b>
          <br/>
          The REWARD Report provides information on the rewards that Operating Managers have sent to team members. This report should be exported out to Payroll to ensure rewards are appropriately taxed.
        </HelpText>
        <Grid
          item
          xs={12}
          container
          justify="space-between"
          className={classes.actions}
        >
          <Grid item>
            <RewardFilters />
          </Grid>
          <Grid item>
            <RewardsDownloadButton />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <RewardsTable />
        </Grid>
      </Grid>
    </DPPageWrapper>
  );
};

export default RewardsReport;
